import Auth from '@/services/Auth';
import { log, errorLog } from '@/utils/logger';
import Vue from 'vue';

export default {
  toggleUserMenu: ({ commit }) => commit('TOGGLE_USER_MENU'),

  setAlertBar: ({ commit }, config) => {
    const { reset, ...configRest } = config;

    const defaultConfig = reset
      ? {
          opened: false,
          message: '',
          actionLabel: '',
          action: null,
        }
      : {};

    commit('SET_ALERT_BAR', { ...defaultConfig, ...configRest });
  },

  verifyMemedAuth: async ({ commit, dispatch, rootGetters }) => {
    const { $zendesk } = Vue.prototype;

    const hasCRM = rootGetters['dashboard/currWorkspace'].council === 'CRM';

    const alertConfig = {
      opened: true,
      message:
        'Ocorreu um erro ao validar seu CRM. Você poderá usar a plataforma mas por hora não poderá prescrever.',
      actionLabel: 'Contactar suporte',
      action: $zendesk.open,
    };

    tryAuth: try {
      if (!hasCRM) break tryAuth;
      const memedAuth = await Auth.getMemedAuth();
      log('memed auth>', memedAuth.actived);

      if (!memedAuth.actived)
        setTimeout(
          () => dispatch('setAlertBar', alertConfig),
          memedAuth.isLocal ? 0 : 3000,
        );
    } catch (err) {
      errorLog(err);
      alert(
        `Ocorreu um erro ao autenticar usuário Memed: ${err?.response.data.msg}`,
      );
    }
  },
};
